import { API } from '../../config/api';
import { DataService } from '../../config/dataService/dataService';
import { paramsToQueryString } from '../../utility/helpers/commonFunction';

// Personal details fetch
export const estimateDetails = ({
    page,
    limit,
    status,
    sortType,
    sortBy,
    text,
    type,
    year,
    makeId,
    modelId,
    date,
    customer,
    licenseNumber,
    fleetUnitNumber,
    provinceId,
    vin,
}) => {
    return async (dispatch) => {
        try {
            const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            let url = `${API.estimate.estimateList}?limit=${limit}&page=${page}&status=${status}&sortType=${sortType}&sortBy=${sortBy}&searchText=${encodeURIComponent(
                text || ''
            )}&type=${type || ''}&vehicleYear=${year || ''}&vehicleMakeId=${makeId || ''}&vehicleModelId=${modelId || ''}&date=${date || ''}&timezone=${encodeURIComponent(
                tz
            )}`;
            if (customer) url += `&customer=${customer}`;
            if (licenseNumber) url += `&licenseNumber=${encodeURIComponent(licenseNumber)}`;
            if (fleetUnitNumber) url += `&fleetUnitNumber=${encodeURIComponent(fleetUnitNumber)}`;
            if (provinceId) url += `&provinceId=${encodeURIComponent(provinceId)}`;
            if (vin) url += `&vin=${encodeURIComponent(vin)}`;
            const response = await DataService.get(url);
            if (!response.data.error) {
                dispatch({
                    type: API.estimate.estimateList,
                    estimateData: response.data,
                    loading: false,
                });
                return response.data.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};

export const estimateData = (estimateId) => {
    return async (dispatch) => {
        try {
            const response = await DataService.get(`${API.estimate.estimateDetail}/${estimateId}`);
            if (!response.data.error) {
                dispatch({
                    type: API.estimate.estimateDetail,
                    estimateDetailData: response.data.data,
                    loading: false,
                });
                return response.data.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};
export const estimateRequestData = (estimateRequestId) => {
    return async (dispatch) => {
        try {
            const response = await DataService.get(`${API.estimate.getEstimateRequestDetails}/${estimateRequestId}`);
            if (!response.data.error) {
                // dispatch({
                //     type: API.estimate.estimateDetail,
                //     estimateDetailData: response.data.data,
                //     loading: false,
                // });
                return response.data.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};
export const deleteDraftEstimate = (estimateId) => {
    return async (dispatch) => {
        try {
            const response = await DataService.delete(`${API.estimate.deleteDraft}/${estimateId}`);
            if (!response.data.error) {
                return response.data.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};
export const serviceCategoryData = (params) => {
    return async (dispatch) => {
        try {
            const queryString = paramsToQueryString(params);
            const response = await DataService.get(API.estimate.servicesCategory + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.estimate.servicesCategory,
                    serviceData: response.data.data,
                    loading: false,
                });
                return response.data.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};
export const serviceSubCategoryListApi = (params) => {
    return async (dispatch) => {
        try {
            const queryString = paramsToQueryString(params);
            const response = await DataService.get(API.estimate.servicesSubCategory + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.estimate.servicesSubCategory,
                    serviceSubData: response.data.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};
export const serviceSubcategoryData = (page, limit, id, canceltoken) => {
    return async (dispatch) => {
        try {
            let qury = `?page=${page}&limit=${limit}`;

            if (id) {
                qury += `&serviceCategoryId=${id}`;
            }

            const response = await DataService.get(`${API.estimate.servicesSubCategory}${qury}`, {}, canceltoken);
            if (!response.data.error) {
                dispatch({
                    type: API.estimate.servicesSubCategory,
                    serviceSubData: response.data.data,
                    loading: false,
                });
                return response.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};
export const termsAndWarrantyData = () => {
    return async () => {
        try {
            const response = await DataService.get(API.estimate.termsAndWarranty);
            if (!response.data.error) {
                return response.data.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};
export const createEstimateData = (params, payload) => {
    return async () => {
        try {
            const queryString = paramsToQueryString(params);
            const response = await DataService.post(API.estimate.createEstimate + queryString, payload);
            if (response.data.status) {
                return response.data.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};

export const updateEstimateData = (id, params, payload) => {
    return async () => {
        try {
            const queryString = paramsToQueryString(params);
            const response = await DataService.put(API.estimate.updateEstimate + id + queryString, payload);
            if (response.data.status) {
                return response.data.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};
export const createEstimateDraftData = (params, payload) => {
    return async () => {
        try {
            const response = await DataService.post(API.estimate.createDraftEstimate, payload);
            if (!response.data.error) {
                return response.data.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};
export const sendEstimate = (estimateId) => {
    return async (dispatch) => {
        try {
            const response = await DataService.post(`${API.estimate.sentEstimateDetails}/${estimateId}`);
            if (!response.data.error) {
                return response.data.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};

export const deleteFinalizedEstimate = async (id) => {
    try {
        const response = await DataService.delete(API.estimate.finalizedDelete + id);
        if (response.data.status) {
            return true;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};
